import { render, staticRenderFns } from "./Doll.vue?vue&type=template&id=a46d016e&scoped=true&"
import script from "./Doll.vue?vue&type=script&lang=js&"
export * from "./Doll.vue?vue&type=script&lang=js&"
import style0 from "./Doll.vue?vue&type=style&index=0&id=a46d016e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46d016e",
  null
  
)

export default component.exports